import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import toExport from "@beeldit/core/services/export";
import {ReportActionContext} from "../report/ReportActionContext";

function useExportReport() {
  const { tableFilters: exportFilters, orderBy } =
    useContext(ReportActionContext);
  const errorHandler = useErrorHandler();
  return () => {
    let filterPath = `relations=box_type`;
    if (exportFilters) {
      for (const [key, value] of Object.entries(exportFilters)) {
        if (value) {
          filterPath += `&${key}=${value}`;
        }
      }
    }
    if (orderBy) {
      filterPath += `&orderBy=${orderBy}`;
    }
    toExport("box_days/report", filterPath)
      .then((response: any) => {
        // Tratar la respuesta como Blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Informe caja.csv`);
        document.body.appendChild(link);
        link.click();

        // Limpieza: elimina el link y el URL del objeto
        if (link.parentNode) {
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useExportReport;
